

import Header from "./harsh/Header";
import Hero from "./harsh/Hero";
import About from "./harsh/About";
import Fact from "./harsh/Fact";
import Skill from "./harsh/Skill";
import Resume from "./harsh/Resume";
import Portfolio from "./harsh/Portfolio";
import Contact from "./harsh/Contact";
import Footer from "./harsh/Footer";

function Marketer() {
  return (
    <>
    
    <Header/>
    <Hero/>
    <main id="main">
      <About/>
      <Fact/>
      <Skill/>
      <Resume/>
      <Portfolio/>
      {/* <Contact/> */}
    </main>
    <Footer/>
     
    </>
  );
}
export default Marketer;
